import {create} from "zustand";
import {ConfEnv} from "../config/config";
import privateRequest from "../Infra/http/private.request";
import useCurrencyStore from "./useCurrency.store";

const HORSE_PROVIDER = "centerhorsesv2__betconnect";
const HORSE_GAME_ID = "centerhorsesv2";

export const useHorsesStore = create((set, _get) => ({
  gameUrl: null,
  loading: false,
  error: null,
  screenMode: window.innerWidth <= 768 ? "fullscreen" : "centered",

  startHorseGame: async (currency = "VES") => {
    set({loading: true, error: null});

    try {
      const selectedCurrency = useCurrencyStore.getState().selectedCurrency;
      const currencyParam = currency || (selectedCurrency ? selectedCurrency.id : "VES");
      const isMobile = window.innerWidth <= 768;

      const url = `${ConfEnv.API_URL.GAMES_INIT}/${HORSE_PROVIDER}/${HORSE_GAME_ID}?currency=${currencyParam}&is_mobile=${isMobile}`;
      const response = await privateRequest.get(url);
      const {gameUrl = null} = response?.data?.data || {};

      set({gameUrl, loading: false, error: null});
    } catch (e) {
      set({loading: false, error: {message: e.message, code: e.status}, gameUrl: null});
    }
  },

  unload: () => {
    set({gameUrl: null, error: null});
  },

  setScreenMode: mode => {
    set({screenMode: mode});
  },

  resetScreenModeToDefault: () => {
    const defaultMode = window.innerWidth <= 768 ? "fullscreen" : "centered";
    set({screenMode: defaultMode});
  },

  clearError: () => {
    set({error: null});
  },
}));
